import styled from 'styled-components';

export const BulkSaveIconWithTooltipWrapperStyled = styled.span`
  margin-left: 5px;
`;
